import Vue from "vue";
import Router from "vue-router";

import dorfladenPage from "./views/dorfladen/dorfladenPage.vue";
import mainPage from "./views/mainPage/index.vue";
import confirmMailPage from "./views/subscriber/confirmSubscriber.vue";
import deleteMailPage from "./views/subscriber/deleteSubscriber.vue";
import singleMessagePage from "./views/dorfladen/viewSingleMessage.vue";
import impressum from "./views/mainPage/impressum.vue";
import datenschutz from "./views/mainPage/datenschutz.vue";

import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      components: { default: mainPage, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 100, navbarTransparent: true }
      }
    },
    {
      path: "/impressum",
      name: "impressum",
      components: { default: impressum, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 100, navbarTransparent: true }
      }
    },
    {
      path: "/datenschutz",
      name: "datenschutz",
      components: { default: datenschutz, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 100, navbarTransparent: true }
      }
    },
    {
      path: "/subscriber/:id/confirm",
      name: "confirmMail",
      components: { default: confirmMailPage, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 100, navbarTransparent: true }
      }
    },
    {
      path: "/subscriber/:id",
      name: "deleteMail",
      components: { default: deleteMailPage, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 100, navbarTransparent: true }
      }
    },
    {
      path: "/message/:id",
      name: "singleMessage",
      components: { default: singleMessagePage, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 100, navbarTransparent: true }
      }
    },
    {
      path: "/dorfladen/:dorfladenId",
      name: "Dorfladen",
      components: { default: dorfladenPage, header: MainNavbar, footer: MainFooter },
      props: {
        default: true,
        header: { colorOnScroll: 100, navbarTransparent: true }
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
